import { SHP_COMMON } from './polyclinics'

export type InstitutionInfo = {
  fullName: string
  appointmentPhone: string
  mssPhone: string
  address: string
  openingHours: readonly { days: string; times: string }[]
  appointmentEmail: string // appointments and enquiries
  mssEmail: string // FA request submissions
  logo: string
  website?: string
}

// TODO confirm details
export const INSTITUTIONS: Record<string, InstitutionInfo> = {
  // TODO(AH)
  // AH: {
  //   fullName: 'Alexandra Hospital',
  //   phone: '6908 2222',
  //   address: '378 Alexandra Road, Singapore 159964',
  //   openingHours: [
  //     { days: 'Mon - Fri', times: '8.30am to 6pm' },
  //     { days: 'Sat', times: '9am to 2.30pm' },
  //     { days: 'Sun', times: 'Closed' },
  //   ],
  //   logo: '/assets/ah-logo.svg',
  // },
  SGH: {
    fullName: 'Singapore General Hospital',
    appointmentPhone: '6321 4377',
    mssPhone: '6321 4377',
    address:
      'Block 3, Level 1, Medical Social Services, Singapore General Hospital, Singapore 169608',
    openingHours: [
      { days: 'Mon - Fri', times: '8am to 6pm' },
      { days: 'Sat - Sun', times: 'Closed' },
    ],
    appointmentEmail: 'mss@sgh.com.sg',
    mssEmail: 'mss@sgh.com.sg',
    logo: '/assets/sgh-logo.png',
  },
  NDC: {
    fullName: 'National Dental Centre Singapore',
    appointmentPhone: '6324 8802',
    mssPhone: '6324 8795',
    address: '5 Second Hospital Avenue, Singapore 168938',
    openingHours: [
      { days: 'Mon - Thu', times: '8am to 5.30pm' },
      { days: 'Fri', times: '8am to 5pm' },
      { days: 'Sat, Sun and PH', times: 'Closed' },
    ],
    appointmentEmail: 'appointment@ndcs.com.sg',
    mssEmail: 'mss@ndcs.com.sg',
    logo: '/assets/ndc-logo.png',
  },
  WH: {
    fullName: 'Woodlands Health',
    appointmentPhone: '6361 6004',
    mssPhone: '6361 6004',
    address:
      'Department of Medical Social Work, Woodlands Health, 17 Woodlands Drive 17, Tower B, Basement 1, Unit 04, Singapore 737628',
    openingHours: [
      { days: 'Mon - Fri', times: '8am to 5pm' },
      { days: 'Sat - Sun', times: 'Closed' },
    ],
    appointmentEmail: 'WH.MSW@nhghealth.com.sg',
    mssEmail: 'WH.MSW@nhghealth.com.sg',
    logo: '/assets/wh-logo.png',
  },
  TTSH: {
    fullName: 'Tan Tock Seng Hospital',
    appointmentPhone: '6357 8222',
    mssPhone: '6256 6011',
    address: '11 Jalan Tan Tock Seng, Singapore 308433',
    openingHours: [
      { days: 'Mon - Fri', times: '8am to 5pm' },
      { days: 'Sat, Sun and PH', times: 'Closed' },
    ],
    appointmentEmail: 'ttsh.msw@nhghealth.com.sg',
    mssEmail: 'ttsh.MSW.Documents@nhghealth.com.sg',
    logo: '/assets/ttsh-logo.png',
  },
  IMH: {
    fullName: 'Institute of Mental Health',
    appointmentPhone: '6389 2059',
    mssPhone: '6389 2059',
    address: '10 Buangkok View, Buangkok Green Medical Park, Singapore 539747',
    openingHours: [
      { days: 'Mon - Thu', times: '8am to 5.30pm' },
      { days: 'Fri', times: '8am to 5pm' },
      { days: 'Sat, Sun and PH', times: 'Closed' },
    ],
    appointmentEmail: 'imh.admin.msw@nhghealth.com.sg',
    mssEmail: 'imh.msw.ff@nhghealth.com.sg',
    logo: '/assets/imh-logo.png',
  },
  CGH: {
    fullName: 'Changi General Hospital',
    appointmentPhone: '6850 2880',
    mssPhone: '6850 2880',
    address:
      '2 Simei St 3, Singapore 529889, Changi General Hospital, Main Building, Medical Social Services, Level 2',
    openingHours: [
      { days: 'Mon - Fri', times: '8.30am to 5.30pm' },
      { days: 'Sat, Sun and PH', times: 'Closed' },
    ],
    appointmentEmail: 'cgh_mss@cgh.com.sg',
    mssEmail: 'cgh_mss@cgh.com.sg',
    logo: '/assets/cgh-logo.png',
  },
  SKH: {
    fullName: 'Sengkang General Hospital',
    appointmentPhone: '6930 5000',
    mssPhone: '6930 6000',
    address: '110 Sengkang East Way, Singapore 544886',
    openingHours: [
      { days: 'Mon - Fri', times: '8.30am to 5.30pm' },
      { days: 'Sat, Sun and PH', times: 'Closed' },
    ],
    appointmentEmail: 'fa.mss@skh.com.sg',
    mssEmail: 'fa.mss@skh.com.sg',
    logo: '/assets/skh-logo.png',
  },
  OCH: {
    fullName: 'Outram Community Hospital',
    appointmentPhone: '6970 3090',
    mssPhone: '6970 3090',
    address: '10 Hospital Blvd, Singapore 168582',
    openingHours: [
      { days: 'Mon - Fri', times: '9am to 5pm' },
      { days: 'Sat, Sun and PH', times: 'Closed' },
    ],
    appointmentEmail: 'ochmss@singhealthch.com.sg',
    mssEmail: 'ochmss@singhealthch.com.sg',
    logo: '/assets/och-logo.png',
  },
  SKC: {
    fullName: 'Sengkang Community Hospital',
    appointmentPhone: '6930 7017',
    mssPhone: '6930 7017',
    address: '1 Anchorvale Street, Singapore 544835',
    openingHours: [
      { days: 'Mon - Fri', times: '9am to 5pm' },
      { days: 'Sat, Sun and PH', times: 'Closed' },
    ],
    appointmentEmail: 'skchmss@singhealthch.com.sg',
    mssEmail: 'skchmss@singhealthch.com.sg',
    logo: '/assets/skc-logo.png',
  },

  // Pseudo-institution
  // Refer to POLYCLINICS for actual details
  SHP: {
    fullName: 'SingHealth Polyclinics',
    appointmentPhone: SHP_COMMON.appointmentPhone,
    mssPhone: SHP_COMMON.mssPhone,
    address: '', // polyclinic-specific
    openingHours: SHP_COMMON.openingHours,
    appointmentEmail: 'SingHealthPolyclinics@singhealth.com.sg', // generic, used when exact polyclinic is not specified
    mssEmail: SHP_COMMON.mssEmail,
    logo: '/assets/shp-logo.png',
    website: SHP_COMMON.website,
  },
} as const
